import React, { Component, PropTypes } from 'react'
import throttle from 'lodash/throttle'
import isFunction from 'lodash/isFunction'

class MouseEvents extends Component {
  raf = null
  defaultVelocityState = {
    lastUpdate: null,
    lastMouseX: 0,
    lastMouseY: 0,
    velocityX: 0,
    velocityY: 0,
    isMouseMoving: false
  }
  defaultState = {
    ...this.defaultVelocityState,
    isMouseOver: false
  }
  timer = null
  state = this.defaultState

  // Lifecycle

  componentWillUnmount () {
    this.timer = null
    cancelAnimationFrame(this.raf)
  }

  // Actions

  resetState () {
    this.setState(this.defaultState)
  }

  // Handlers

  handleTimeout = () => {
    const { lastUpdate } = this.state

    if (Date.now() - lastUpdate > this.props.checkInterval) {
      this.setState(this.defaultVelocityState)
      this.timer = null
    }
  }

  handleMouseOver = e => {
    const now = Date.now()
    const lastMouseX = e.pageX
    const lastMouseY = e.pageY
    const isMouseMoving = true
    const isMouseOver = true

    this.props.onMouseOver()
    this.setState({ lastUpdate: now, lastMouseX, lastMouseY, isMouseMoving, isMouseOver })
  }

  throttledHandleMouseMove = throttle(e => {
    const now = Date.now()
    const { lastUpdate } = this.state

    if (!lastUpdate) { return }

    const mouseX = e.pageX
    const mouseY = e.pageY
    const deltaT = now - lastUpdate
    const deltaX = mouseX - this.state.lastMouseX
    const deltaY = mouseY - this.state.lastMouseY

    const velocityX = Math.round(deltaX / deltaT * 100) / 100
    const velocityY = Math.round(deltaY / deltaT * 100) / 100

    const isMouseMoving = true

    this.raf = requestAnimationFrame(() => {
      this.props.onMouseMove({ velocityX, velocityY })
      this.setState({
        lastUpdate: now,
        lastMouseX: mouseX,
        lastMouseY: mouseY,
        velocityX,
        velocityY,
        isMouseMoving
      })
      this.timer = setTimeout(this.handleTimeout, this.props.checkInterval)
    })
  }, this.props.checkInterval, { trailing: true, leading: true })

  handleMouseMove = e => {
    e.persist()
    this.throttledHandleMouseMove(e)
  }

  handleMouseOut = () => {
    this.props.onMouseOut()
    this.resetState()
    cancelAnimationFrame(this.raf)
    this.raf = null
  }

  // Rendering

  render () {
    const { velocityX, velocityY, isMouseOver } = this.state
    const { children, enabled } = this.props

    return (
      <div
        onMouseOver={enabled && this.handleMouseOver}
        onMouseMove={enabled && this.handleMouseMove}
        onMouseOut={enabled && this.handleMouseOut}
      >
        { isFunction(children) ? children({ velocityX, velocityY, isMouseOver }) : children}
      </div>
    )
  }

}

MouseEvents.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  checkInterval: PropTypes.number.isRequired,
  onMouseOver: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseOut: PropTypes.func,
  enabled: PropTypes.bool
}

MouseEvents.defaultProps = {
  checkInterval: 0.200 * 1000,
  onMouseOver: () => {},
  onMouseMove: () => {},
  onMouseOut: () => {},
  enabled: true
}

export default MouseEvents



// WEBPACK FOOTER //
// ./src/components/utility/MouseEvents.js